import { render, staticRenderFns } from "./tab_announcement.vue?vue&type=template&id=581464b1"
import script from "./tab_announcement.vue?vue&type=script&lang=js"
export * from "./tab_announcement.vue?vue&type=script&lang=js"
import style0 from "./tab_announcement.vue?vue&type=style&index=0&id=581464b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports